import { Lock, Server, EyeOff, KeyRound, MonitorOff } from "lucide-react";

const points = [
  { icon: KeyRound, text: "No account required." },
  { icon: EyeOff, text: "No productivity surveillance." },
  { icon: MonitorOff, text: "No shame-based scoring." },
  { icon: Server, text: "Optional AI controls." },
  { icon: Lock, text: "Local-first by design." },
];

export default function Privacy() {
  return (
    <section
      id="privacy"
      data-testid="privacy-section"
      className="px-6 lg:px-10 py-24 lg:py-32"
    >
      <div className="max-w-4xl mx-auto text-center fade-up">
        <p className="text-sm tracking-[0.18em] uppercase font-semibold text-[#475569]">
          Privacy
        </p>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-[1.05]">
          Your focus patterns are not a product.
        </h2>
        <p className="mt-6 text-lg text-[#475569] leading-relaxed max-w-2xl mx-auto">
          Mindrail is local-first. Your tasks, parked thoughts, voice notes,
          behavioural signals, session history, and settings are stored in
          Chrome&apos;s local extension storage. The product is designed
          around privacy: no account required, no surveillance-based workflow.
        </p>
        <p className="mt-4 text-base text-[#475569] max-w-2xl mx-auto">
          Optional AI features can use your own OpenAI-compatible key. Page
          summaries, memory summaries, and cloud AI are controlled by
          user-facing settings.
        </p>
        <p className="mt-4 text-base text-[#475569] max-w-2xl mx-auto">
          Privacy-safe telemetry for reliability and feature usage can be
          disabled in Settings. It does not include page text, URLs, task text,
          parked thought content, or AI prompts.
        </p>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
          {points.map((p, i) => (
            <div
              key={i}
              data-testid={`privacy-point-${i}`}
              className="flex items-center gap-3 rounded-2xl bg-white border border-[#E2E8F0] px-4 py-3.5 text-left"
            >
              <p.icon
                className="w-4 h-4 text-[#22C55E] shrink-0"
                strokeWidth={1.5}
              />
              <span className="text-sm text-[#0F172A]">{p.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
